import { render, staticRenderFns } from "./InvestmentSuccess.vue?vue&type=template&id=61ef516f&scoped=true"
import script from "./InvestmentSuccess.vue?vue&type=script&lang=js"
export * from "./InvestmentSuccess.vue?vue&type=script&lang=js"
import style0 from "./InvestmentSuccess.vue?vue&type=style&index=0&id=61ef516f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef516f",
  null
  
)

export default component.exports